import * as Analytics from 'analytics';

export const trackSearchCategoryChanges = evt => {
    const selectBox = evt.target;
    const selectedOption = selectBox.selectedOptions[0];
    const selectedValue = selectedOption.value;
    const selectedText = selectedOption.text;

    Analytics.trackEvent({
        category: 'Search box',
        action: 'SelectCategory',
        label: 'Category: ' + selectedText + ' | CategoryID: ' + selectedValue
    });
};

export const trackSearch  = () => {
    Analytics.trackEvent({
        category: 'Search box',
        action: 'Navigation',
        label: 'normal'
    });
};

export const trackSubmitButton  = () => {
    Analytics.trackEvent({
        category: 'Search box',
        action: 'Navigation',
        label: 'Submit button click'
    });
};

export const trackResetButton  = () => {
    Analytics.trackEvent({
        category: 'Search box',
        action: 'Navigation',
        label: 'Reset button click'
    });
};


// WEBPACK FOOTER //
// ./src/EbaySweden.TouchWeb/static/script/components/search/search.analytics.js